import styled from "styled-components";
import locationIcon from "../../../../assets/Mayo/Location.svg";

export default function LocationListItem({ address, subAddress, firstArrival, lastDeparture}) {
  return (
    <Container>
      <Image src={locationIcon} />
      <AddressInfo>
        <Address>
          {address}
        </Address>
        <Text>
          {subAddress}
        </Text>
        <Text>
          First Arrival | After {firstArrival}
        </Text>
        <Text>
          Last Departure | {lastDeparture}
        </Text>
      </AddressInfo>
    </Container>
  );
} 

const Container = styled.div`
  display: flex;
  gap: 15px;
  color: #1A1A1A;
  margin-bottom: 24px;
`

const AddressInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

const Image = styled.img`
  width: 13px;
  height: 20px;
  margin-top: 3px;
`

const Address = styled.p`
  margin: 0;
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 6px;
`

const Text = styled.p`
  margin: 0;
  font-size: 17px;
  color: #000000;
`